
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/AllOccasionsPage/AllOccasionsPage",
      function () {
        return require("private-next-pages/events/AllOccasionsPage/AllOccasionsPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/AllOccasionsPage/AllOccasionsPage"])
      });
    }
  